export default __webpack_public_path__ + "static/media/new-hero-5.17bad8a9.svg";